import { Language } from '../../types';
import { useLanguage } from '../../contexts/LanguageContext';
import { Button } from './Button';

interface LanguageSelectorProps {
  className?: string;
}

export function LanguageSelector({ className = '' }: LanguageSelectorProps) {
  const { language, setLanguage } = useLanguage();

  const languages: { code: Language; name: string }[] = [
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' },
  ];

  return (
    <div className={`flex-row gap-s ${className}`}>
      {languages.map((lang) => (
        <Button
          key={lang.code}
          onClick={() => setLanguage(lang.code)}
          selected={language === lang.code}
          aria-label={`Switch to ${lang.name}`}
        >
          {lang.name}
        </Button>
      ))}
    </div>
  );
}